module.exports = __webpack_public_path__ + "static/media/albertsons.722fb80a.svg";